import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "messages"
const MessagesIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12.75 12.75H6.75V11.25H12.75zM17.25 8.625H6.75V7.125H17.25z" />
          <path
            fillRule="evenodd"
            d="M21 3C21.828 3 22.5 3.672 22.5 4.5V16.5C22.5 17.328 21.828 18 21 18H12.602L7.75 21.235C7.001 21.733 6 21.198 6 20.3V18H3C2.172 18 1.5 17.328 1.5 16.5V4.5C1.5 3.672 2.172 3 3 3zM3 16.5H7.5V19.598L12.148 16.5H21V4.5H3z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default MessagesIcon
